// export const IMG_SERVER_URL = "http://localhost:4000";
export const IMG_SERVER_URL =
  "https://design-api.airbrickinfra.com/api/minio/static";

export const MAX_COMPANY_NAME_LENGTH = 40;
